import DangerousGoods from '../../pages/DangerousGoods'
import Electrical from '../../pages/Electrical'
import FinalPage from '../../pages/FinalPage'
import Home from '../../pages/Home'
import Noise from '../../pages/Noise'
import Planning from '../../pages/Planning'
import ScopeOfWorks from '../../pages/ScopeOfWorks'
import SurfacePreparartion from '../../pages/SurfacePreparartion'
import Transporting from '../../pages/Transporting'
import WorkareaSetup from '../../pages/WorkareaSetup'
import WorkingEnvironment from '../../pages/WorkingEnvironment'
import WorkSite from '../../pages/WorkSite/WorkSite'

export const steps = [
  {
    title: 'home',
    input: <Home />,
  },
  {
    title: 'Attending work site',
    input: <WorkSite />,
  },
  {
    title: 'Planning',
    input: <Planning />,
  },
  {
    title: 'Transporting painting',
    input: <Transporting />,
  },
  {
    title: 'Workarea setup',
    input: <WorkareaSetup />,
  },
  {
    title: 'Surface Preparation',
    input: <SurfacePreparartion />,
  },
  {
    title: 'Noise',
    input: <Noise />,
  },
  {
    title: 'Electrical',
    input: <Electrical />,
  },
  {
    title: 'Working Enviornment',
    input: <WorkingEnvironment />,
  },
  {
    title: 'Dangerous Goods',
    input: <DangerousGoods />,
  },
  {
    title: 'Completion of scope of work',
    input: <ScopeOfWorks />,
  },
  {
    title: 'Final Page',
    input: <FinalPage />,
  },
]
